export const Permissions = Object.freeze({});
